export default __webpack_public_path__ + "static/media/paper.67339fe2.jpg";